import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class PlantillasService extends ApiService {
  entityType = EntityType.PLANTILLA;
  url = 'api/plantillas/';
}
